import { render, staticRenderFns } from "./AlertHelp.modal.vue?vue&type=template&id=6c0c2d96&"
import script from "./AlertHelp.modal.vue?vue&type=script&lang=js&"
export * from "./AlertHelp.modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports